import { render, staticRenderFns } from "./groupFitnessDashboardDownloads.vue?vue&type=template&id=713ad4de&scoped=true"
import script from "./groupFitnessDashboardDownloads.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardDownloads.vue?vue&type=script&lang=js"
import style0 from "./groupFitnessDashboardDownloads.vue?vue&type=style&index=0&id=713ad4de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713ad4de",
  null
  
)

export default component.exports